import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  width: "46.173",
  height: "35.13",
  viewBox: "0 0 46.173 35.13"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<defs><clipPath id=\"a\"><rect width=\"46.173\" height=\"35.13\" fill=\"#ff9f0a\"></rect></clipPath></defs><g transform=\"translate(0 0)\" clip-path=\"url(#a)\"><path d=\"M37.195,6.61,35.089,8.273A14.747,14.747,0,0,0,8.782,17.431c0,.416.013.845.054,1.26H14.87L7.442,26.307,0,18.691H6.154c-.04-.416-.054-.845-.054-1.26A17.429,17.429,0,0,1,37.195,6.61\" transform=\"translate(0 0)\" fill=\"#ff9f0a\"></path><path d=\"M6.7,26.277,8.8,24.614a14.747,14.747,0,0,0,26.307-9.158c0-.416-.013-.845-.054-1.26H29.021L36.449,6.58,43.891,14.2H37.736c.04.416.054.845.054,1.26A17.429,17.429,0,0,1,6.7,26.277\" transform=\"translate(2.282 2.243)\" fill=\"#ff9f0a\"></path></g>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}